import { useState } from "react";
import SidePanel from "../SidePanel";
import Editor from "./Editor";
import Viewer from "./Viewer";

function Content(props) {
  const [eventId, setEventId] = useState(props.eventId);

  return !eventId ? (
    <Editor {...props} setEventId={setEventId} eventId={eventId} />
  ) : (
    <Viewer {...props} setEventId={setEventId} eventId={eventId} />
  );
}

function EventSidePanel({ trigger, ...props }) {
  return (
    <SidePanel
      trigger={trigger}
      content={({ hide }) => <Content hide={hide} {...props} />}
    />
  );
}

export default EventSidePanel;
